import React, { useEffect, useState } from "react";
import { Header, ConfirmModal } from "../../components";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase-config";
import Layout from "../layout/Layout";
import { TableButton } from "../../components";
import TextField from "@mui/material/TextField";
import { AiFillEye } from "react-icons/ai";
import { MdModeEditOutline, MdOutlineCancel, MdOutlineSecurity } from "react-icons/md";
import Paper from "@mui/material/Paper";
import "./users.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import BeatLoader from "react-spinners/BeatLoader";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchUsers } from "../../services/users";
import Excel from "../../utils/Excel";
import { DynamicTableCell, useTableContext } from "../../contexts/TableContext";
import IpWhitelistModal from "../../components/forms/IpWhitelistForm/IpWhitelistModal";

const columns = [
  {
    id: "firstName",
    label: "Name",
    minWidth: 140,
  },
  {
    id: "username",
    label: "Username",
    minWidth: 140,
  },
  {
    id: "phone",
    label: "Phone number",
    minWidth: 140,
  },
  {
    id: "role",
    label: "Role",
    minWidth: 140,
  },
  {
    id: "country",
    label: "Country",
    minWidth: 100,
  },
  {
    id: "balance",
    label: "Balance (EUR)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "created at",
    label: "Created at",
    minWidth: 80,
    align: "right",
  },
  {
    id: "actions",
    label: "Action",
    minWidth: 80,
    align: "right",
  },
];

const override = {
  textAlign: "center",
  marginTop: "20px",
};


const AllUsers = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [page, setPage] = React.useState(0);
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [blockUserId, setBlockUserId] = useState(null);
  const [authToken, setAuthToken] = useState("");
  const { loading, setLoading } = useTableContext();
  const ipModalRef = React.useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSetBlockUserData = (id) => {
    setBlockUserId(id);
    setShowConfirmModal(true);
  };

  const handleBlockUser = async (id) => {
    try {
      setShowConfirmModal(false);

      await blockUsersAccount(id);

      toast.success("Blocked User Successfuly", {
        pauseOnHover: false,
        closeOnClick: true,
      });

      if (authToken) {
        loadUsers(authToken, page, rowsPerPage);
      }
    } catch (error) {
      toast.error("Error  Blocking User", {
        pauseOnHover: false,
        closeOnClick: true,
      });
    }
  };

  const loadUsers = (token, pageIndex = 0, pageSize = 10) => {
    const offset = Number(pageIndex) * Number(pageSize);
    const limit = Number(pageSize) || 10;
    setLoading(true);
    fetchUsers(token, { offset, limit })
      .then((res) => {
        if (res.status_code == 200) {
          setUsers(res.data?.users || []);
          setTotalCount(Number(res.data?.total) || 0);
        } else if (
          res.status_code == 404 ||
          /no users/i.test(res.message || "")
        ) {
          setUsers([]);
          setTotalCount(0);
        } else {
          setUsers([]);
          setTotalCount(0);
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        console.log("ERROR: ", err);
        setUsers([]);
        setTotalCount(0);
        toast.error(`${err}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!user) return;
    user.getIdToken(true).then((token) => {
      setAuthToken(token);
    });
  }, [user]);

  useEffect(() => {
    if (!authToken) return;
    loadUsers(authToken, page, rowsPerPage);
  }, [authToken, page, rowsPerPage]);

  let exportData = (_type) => {
    let tab = users.map((item) => {
      let obj = {
        id: item.user_id,
        name: item.first_name,
        username: item.username,
        email: item?.email,
        phone_number: item?.phone_number,
        country: item?.address?.country?.name,
        address: item?.address?.address,
        type: item?.role?.name,
        created_at: new Date(item.created_at).toDateString(),
        updated_at: new Date(item.updated_at).toDateString(),
      };

      return obj;
    });
    if (_type === "csv") Excel.writeFile(tab, "users", "csv");
    else Excel.writeFile(tab, "users");
  };

  return (
    <Layout>
      <div className="m-2 md:m-10 mt-24 p-2 md:p-5 bg-white rounded-3xl">
        <Header category="Users Table" title="" />
        <div className="flex justify-between mb-5">
          <div className="flex items-end gap-2">
            {/* export btns */}
            <TableButton
              text="CSV"
              color="#45B4CB"
              onClick={() => exportData("csv")}
            />
            <TableButton
              text="Excel"
              color="#58BC6E"
              onClick={() => exportData()}
            />
            <TableButton
              text="PDF"
              color="#E61F63"
              onClick={() => window.print()}
            />
            {/* <TableButton text="Print" color="#6563EE" /> */}
          </div>
          <div className="">
            {/* search */}
            <div className="flex items-end gap-2">
              <p>Search: </p>
              <TextField
                style={{ width: "90%" }}
                InputLabelProps={{ fontSize: "8px" }}
                id="standard-basic"
                variant="standard"
              />
            </div>
          </div>
        </div>
        <>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer
              sx={{ minWidth: 600 }}
              style={{ boxShadow: "none" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column, index) => (
                      <TableCell
                        key={column.id}
                        align="left"
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          <DynamicTableCell>
                            <TableCell align="left">{row.first_name}</TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">{row.username}</TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">
                              {row.phone_number}
                            </TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">
                              {row.role?.name}
                            </TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">
                              {row.address?.country?.name}
                            </TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">
                              {row.wallet?.balance}
                            </TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="left">
                              {new Date(row.created_at).toDateString()}
                            </TableCell>
                          </DynamicTableCell>
                          <DynamicTableCell>
                            <TableCell align="center">
                              <div className="flex gap-2">
                                <Tippy content="View Profile" animation="fade">
                                  <button
                                    onClick={() =>
                                      navigate(`/users/${row?.id}`)
                                    }
                                    className="bg-[#00A5EE] rounded-full text-[#fff] p-2"
                                  >
                                    <AiFillEye size={16} color="#fff" />
                                  </button>
                                </Tippy>
                                {row.role?.name === "MERCHANT" && (
                                  <Tippy content="Allowed IPs" animation="fade">
                                    <button
                                      onClick={() =>
                                        ipModalRef.current.open(row?.id)
                                      }
                                      className="bg-[#405B9C] rounded-full text-[#fff] p-2"
                                    >
                                      <MdOutlineSecurity size={16} color="#fff" />
                                    </button>
                                  </Tippy>
                                )}
                                {/* <button onClick={() => handleDelete(users[index])} className="bg-[#FDBE07] rounded-full text-[#fff] p-2">
                            <MdModeEditOutline size={16} color="#fff"/>
                          </button>
                          <button onClick={() => handleDelete(users[index])} className="bg-[#35CA28] rounded-full text-[#fff] p-2">
                            <MdMap size={16} color="#fff"/>
                          </button> */}
                                <Tippy content="Suspend" animation="fade">
                                  <button
                                    onClick={() =>
                                      handleSetBlockUserData(row?.id)
                                    }
                                    className="bg-[#F6B462] rounded-full text-[#fff] p-2"
                                  >
                                    <MdOutlineCancel size={16} />
                                  </button>
                                </Tippy>

                                {/* <Tippy content="Block User"  animation="fade">
                          <button onClick={() => handleBlockUser(users[index])} className="bg-[#EA5C27] rounded-full text-[#fff] p-2">
                            <BsTrash size={14} color="#fff"/>
                          </button>
                          </Tippy> */}
                              </div>
                            </TableCell>
                          </DynamicTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <BeatLoader
              color="#36d7b7"
              loading={loading}
              cssOverride={override}
            />
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </>
      </div>

      {showConfirmModal && (
        <ConfirmModal
          title="Are you sure you want to suspend user ?"
          onAccept={() => handleBlockUser(blockUserId)}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
      <IpWhitelistModal ref={ipModalRef} authToken={authToken} />
    </Layout>
  );
};
export default AllUsers;
